import { useField } from "formik";
import { FunctionComponent } from "react";

import { ReactComponent as CircleOk } from "@src/modules/shared/components/Results/icons/circle-ok.svg";
import {
  FailedTestCircle,
  LabelCell,
  ValueCell,
} from "@src/modules/shared/components/Results/ResultRow/ResultRow.components";
import ResultCheckboxField from "@src/modules/shared/components/Results/ResultCheckboxField";
import { ResultsTableRow } from "@src/modules/shared/components/Results/ResultsForm.components";
import { CustomResultInput } from "@src/modules/shared/components/Results/shared/components";
import { EditCustomResultsFormValue } from "@src/modules/shared/components/Results/CustomResults";
import Button from "@src/modules/shared/components/Button";
import { ReactComponent as Bin } from "@src/modules/shared/icons/bin.svg";

interface Props {
  result: EditCustomResultsFormValue;
  isEdit: boolean;
  resultIndex: number;
  handleDeleteRow: (index: number) => void;
}

const CustomResultRow: FunctionComponent<Props> = ({
  result,
  isEdit,
  resultIndex,
  handleDeleteRow,
}) => {
  const [labelField, labelMeta] = useField(`results[${resultIndex}].label`);
  const [valueField, valueMeta] = useField(`results[${resultIndex}].value`);
  const [isPassedField] = useField(`results[${resultIndex}].isPassed`);

  return (
    <ResultsTableRow key={resultIndex}>
      {isEdit ? (
        <>
          <LabelCell>
            <CustomResultInput
              {...labelField}
              value={labelField.value ?? ""}
              hasError={labelMeta.touched && !!labelMeta.error}
              placeholder={result.label}
            />
          </LabelCell>
          <ValueCell>
            <CustomResultInput
              {...valueField}
              value={result.value ?? ""}
              hasError={valueMeta.touched && !!valueMeta.error}
              placeholder={result.value}
            />
          </ValueCell>
          <ValueCell>
            <ResultCheckboxField {...isPassedField} />
          </ValueCell>
          <ValueCell>
            <Button
              buttonType="tertiary"
              onClick={() => handleDeleteRow(resultIndex)}
            >
              <Bin />
            </Button>
          </ValueCell>
        </>
      ) : (
        <>
          <LabelCell>{result.label}</LabelCell>
          <ValueCell>{result.value}</ValueCell>
          <ValueCell>
            {!result.isPassed ? <FailedTestCircle /> : <CircleOk />}
          </ValueCell>
        </>
      )}
    </ResultsTableRow>
  );
};

export default CustomResultRow;
